import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { ConfigService } from '../ConfigService';
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class PerformanceReviewService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
        private urlService: UrlService,
        private configData: ConfigService
	){
		this.url = urlService.getURL('PerformanceReview');
	}
	
    loadAllByDateRange(id: System.Guid, start: Date, finish: Date): Observable<ePM.Logic.PerformanceReview[]> {
        var urlStr = this.url + '?personID=' + (id || '') + "&start=";
        if (start) {
            urlStr += this.configData.CombineDateAndTime(start, null).toISOString();
        } else {
            urlStr += '1/1/1900';
        }
        urlStr += "&finish=";
        if (finish) {
            urlStr += this.configData.CombineDateAndTime(finish, null).toISOString();
        } else {
            urlStr += '1/1/2500';
        }
        return this.myBaseService.loadAll(urlStr);
    }
	loadAllForPerson(id: System.Guid): Observable<ePM.Logic.PerformanceReview[]> {
		return this.myBaseService.loadAll(this.url + '/Person/' + (id || ''));
	}
	reassign(perfReviewID: System.Guid, reviewerID: System.Guid): Observable<ePM.Logic.PerformanceReview> {
		return this.myBaseService.post(reviewerID, this.url + '/Reassign/' + (perfReviewID || ''));
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.PerformanceReview> {
		return this.myBaseService.save(tempItem, this.url);
	}
	saveSelf(tempItem: ECI.Basic.ObjectBase): Observable<ePM.Logic.PerformanceReview> {
		return this.myBaseService.save(tempItem, this.url + '/Self');
	}
	submit(id: System.Guid): Observable<ePM.Logic.PerformanceReview> {
		return this.myBaseService.post(null, this.url + '/Submit/'+ (id || ''));
	}
	approve(id: System.Guid): Observable<ePM.Logic.PerformanceReview> {
		return this.myBaseService.post(null, this.url + '/Approve/' + (id || ''));
	}
	startForPerson(id: System.Guid): Observable<ePM.Logic.PerformanceReview> {
		return this.myBaseService.post(null, this.url + '/Start/' + (id || ''));
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.PerformanceReview> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.PerformanceReview>{
		return this.myBaseService.get(id, this.url);
	}
	getEditSelf(id: System.Guid): Observable<ePM.Logic.PerformanceReview> {
		return this.myBaseService.get(id, this.url + '/EditSelf');
	}
	download(id: System.Guid): Observable<BlobResponse>{
		return this.myBaseService.returnBlob(null, this.url + '/Pdf/' + id);
	}
}
